import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Notifications from '@kyvg/vue3-notification'
import App from './App.vue'
import router from './router'
import UdcSelect from '@/components/common/UdcSelect.vue'
import Popup from '@/components/common/Popup/Popup.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBellSlash, faBell, faClose } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faBellSlash, faBell, faClose)

const pinia = createPinia()

const app = createApp(App)

app.use(router)
app.use(pinia)
app.use(Notifications)
app.component('UdcSelect', UdcSelect)
app.component('Popup', Popup)
app.component('fa-icon', FontAwesomeIcon)
app.mount('#app')

export default app
